export default "__VITE_ASSET__f6447be8__"